import * as types from './types'

export const actions = {
    // 设置页面所处环境
    [types.SET_ENV]({commit}, env) {
        commit(types.SET_ENV, env)
    },

    // 记录注册手机号
    [types.SET_CELLPHONE]({commit}, cellphone) {
        commit(types.SET_CELLPHONE, cellphone)
    },

    // 设置活动详情数据
    [types.SET_ACTIVITYDATA]({commit}, activityData) {
        commit(types.SET_ACTIVITYDATA, activityData)
    },

    // 记录报名信息
    [types.SET_FILLINFO]({commit}, fillinfo) {
        commit(types.SET_FILLINFO, fillinfo)
    },

    // 记录课程详情数据
    [types.SET_LESSON]({commit}, lesson) {
        commit(types.SET_LESSON, lesson)
    },

    // 记录推荐人信息
    [types.SET_PROFILE]({commit}, profile) {
        commit(types.SET_PROFILE, profile)
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js